import React from "react";

function About() {
  return (
    <>
      <div className="about">
        <div className="contain">
          <center>
            <h1>WHO AM I?</h1>
          </center>
          <p>
            I am <strong>Syed Wajahat Ali</strong>, a{" "}
            <strong>Computer Science</strong> student currently pursuing my
            degree in <strong>Bahria University Karachi Campus</strong>.
            <br></br>
            <br></br>My major interest is in{" "}
            <strong>Mobile App Development</strong>. I have developed multiple{" "}
            <strong>Android</strong> & <strong>Cross-platform</strong> Apps.
          </p>
        </div>
      </div>

      <div className="about2">
        <div className="contain2">
          <center>
            <h1>My Skill Set?</h1>
          </center>
          <p>
            As a <strong>Mobile App Developer</strong>, I have honed my skills
            in designing and developing high-quality applications for various
            platforms. My expertise lies in{" "}
            <strong>Android App Development</strong> and{" "}
            <strong>Cross-Platform Development</strong>, and I have experience
            working with tools such as <strong>Android Studio</strong> and{" "}
            <strong>React Native</strong>.<br></br> <br></br> Additionally, I am
            also well-versed in <strong>backend development</strong>, including
            integration with APIs and databases.<br></br> Overall, I am a{" "}
            <strong>creative and skilled Mobile App Developer</strong> with a
            passion for creating applications that enhance the user experience
            and solve real-world problems.
          </p>
        </div>
      </div>

      <div className="about3">
        <div className="contain3">
          <center>
            <h1>My Wakatime States?</h1>
          </center>
          
          <a href="https://wakatime.com"><img src="https://wakatime.com/share/@Wajeeez/65ecf460-1342-48fe-baa0-22d943d6f096.png" alt="chart"/></a>
          <center><a href="https://wakatime.com/@afc039dd-fe40-41e1-8e55-9fbc9ab71360"><img src="https://wakatime.com/badge/user/afc039dd-fe40-41e1-8e55-9fbc9ab71360.svg" alt="Total time coded since Sep 11 2021" /></a>
          </center>
        </div>
      </div>


    </>
  );
}

export default About;
